// extracted by mini-css-extract-plugin
export default {"img":"img--W4Q-n","body":"body--W4Q-n","link":"link--W4Q-n","costModuleButton":"costModuleButton--W4Q-n","textWrap":"textWrap--W4Q-n","head":"head--W4Q-n"};